import { useEffect, useState } from "react"
import { Link } from "react-router-dom";

export default function OpenMapsButton({ lat, lon, name }) {

    const [isApple, setIsApple] = useState(false);

    useEffect(() => {
        // detect of user is on mac or ios
        const useragent = navigator.userAgent;
        const appleclients = [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod',
            'Macintosh',
            'MacIntel',
            'MacPPC',
            'Mac68K',
            'macOS'
        ]
        for (let i = 0; i < appleclients.length; i++) {
            if (useragent.indexOf(appleclients[i]) !== -1) setIsApple(true);
        }
        // iPad on iOS 13 detection
        if (navigator.userAgent.includes("Mac") && "ontouchend" in document) {
            setIsApple(true);
        }
    }, [])


    if (isApple) return (
           <Link className='event-action' to={`https://maps.apple.com/place?coordinate=${lat},${lon}&name=${name}`}>
            <button>Open in Apple Maps</button>
        </Link>
    )

    return (
        <Link className='event-action' to={`https://www.google.com/maps/place/${lat},${lon}/`}>
            <button>Open in Google Maps</button>
        </Link>
    )
}
